import { PropTypes } from 'prop-types';
import styles from './index.module.scss';
import { getMonitoringDataHistoricals } from '../../../../../../../services/api/thermalControl/monitoring';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { MainContext } from '../../../../../../../context/MainContext';
import ChannelsPickers from './components/ChannelsPickers';
import AntdRangePicker from '../../../../../../../components/AntdRangePicker';

const { headerWrapper, wrapper, chartWrapper } = styles;

const ChartWrapper = ({
  render,
  monitoringId,
  range,
  onChange,
  availableChannels,
  finished,
}) => {
  const noDataFoundTimeOut = useRef();
  const realTimeInterval = useRef();
  const { setError } = useContext(MainContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [channelRange, setChannelRange] = useState([undefined, undefined]);

  const getData = useCallback(
    async (id) => {
      try {
        const {
          data: { data },
        } = await getMonitoringDataHistoricals({
          monitoringId,
          startDate: range[0].toISOString(),
          endDate: range[1].toISOString(),
        });

        setData(data);
        setLoading(false);
      } catch (e) {
        if (e.response.status === 425) {
          if (noDataFoundTimeOut.current) {
            clearTimeout(noDataFoundTimeOut.current);
            noDataFoundTimeOut.current = undefined;
          }
          noDataFoundTimeOut.current = setTimeout(() => getData(id), 10000);
        } else {
          setError(e.response);
          setLoading(false);
        }
      }
    },
    [monitoringId, range, setError],
  );

  useEffect(() => {
    if (monitoringId) {
      setLoading(true);
      getData(monitoringId);

      return () => clearTimeout(noDataFoundTimeOut.current);
    }
  }, [monitoringId, getData, range, setError]);

  useEffect(() => {
    if (!finished) {
      realTimeInterval.current = setInterval(() => {
        getData(monitoringId);
      }, 60000);
    }
    return () => {
      clearInterval(realTimeInterval.current);
    };
  }, [monitoringId, getData, finished]);

  return (
    <div className={wrapper}>
      <div
        className={headerWrapper}
        style={{
          justifyContent: availableChannels ? 'space-between' : 'flex-end',
        }}
      >
        {availableChannels && (
          <ChannelsPickers
            availableChannels={availableChannels}
            onChange={setChannelRange}
            channelRange={channelRange}
          />
        )}
        <div>
          <AntdRangePicker defaultValue={range} onChange={onChange} />
        </div>
      </div>
      <div className={chartWrapper}>
        {render({ loading, data, range, channelRange })}
      </div>
    </div>
  );
};

ChartWrapper.propTypes = {
  render: PropTypes.func.isRequired,
  monitoringId: PropTypes.number,
  name: PropTypes.string,
  range: PropTypes.arrayOf(PropTypes.object).isRequired,
  onChange: PropTypes.func.isRequired,
  availableChannels: PropTypes.arrayOf(
    PropTypes.shape({
      channel: PropTypes.string,
      description: PropTypes.string,
    }),
  ),
  finished: PropTypes.bool.isRequired,
  monitoringName: PropTypes.string,
};

ChartWrapper.defaultProps = {
  name: '',
  monitoringId: undefined,
  availableChannels: undefined,
  monitoringName: '',
};
export default ChartWrapper;
